import React, { Component } from 'react';
import { Layout, Row, Col, Menu, Icon } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import './layout.css';
import moment from 'moment';

const { Footer } = Layout;


class NESAFooter extends Component {

    constructor(props) {
        super(props)
        this.logout = this.logout.bind(this);
    }

    logout = () => {
        this.props.actions.logout()
    }

    componentDidMount = () => {
        //this.props.actions.getProfileInfo()
    }

    render() {
        return (
            <div className='nesa-footer'>
                <Footer>
                    <ul className='social-link'>
                        <li className="cursor"><a target="_blank" href="https://www.facebook.com/ScoutingAlumniOfficial"><i className="fa fa-facebook fa-2x" aria-hidden="true"></i></a></li>
                        <li className="cursor"><a target="_blank" href="https://www.instagram.com/scoutingalumniofficial/"><i className="fa fa-instagram fa-2x" aria-hidden="true"></i></a></li>
                        {/* <li className="cursor"><a target="_blank" href="https://twitter.com/bsaalumni?lang=en"><i className="fa fa-twitter fa-2x" aria-hidden="true"></i></a></li>
                        <li className="cursor"><a target="_blank" href="https://www.youtube.com/@BSAAlumniAssociation/featured"><i className="fa fa-youtube fa-2x" aria-hidden="true"></i></a></li> */}
                    </ul>

                    <span>© {moment().format('YYYY')} Scouting Alumni – All Rights Reserved</span>

                    <ul>
                        <li className="cursor"><a target="_blank" href="https://scoutingalumni.org/about/">About</a></li>
                        <li className="cursor"><a target="_blank" href="https://nesa.org/resources/faq-2/">FAQ</a></li>
                        <li className="cursor"><a target="_blank" href="https://scoutingalumni.org/about/contact-us/"> Contact </a></li>
                        < br  className="visible-xs"/>
                        <li className="cursor"><a target="_blank" href="https://www.scouting.org/legal/terms-and-conditions/">Terms</a></li>
                        <li className="cursor"><a target="_blank" href="https://www.scouting.org/legal/privacy-policy/">Privacy Policy</a></li><br  className="visible-xs"/>
                        <li className="cursor"><a target="_blank" href="https://www.scouting.org/legal/donor-privacy-policy/">Donor Policy </a></li> <br  className="visible-xs"/>
                        
                    </ul>

                </Footer>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        logout: state.authenticationReducer.logout,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(NESAFooter);




// WEBPACK FOOTER //
// ./src/components/Inc/NESAFooter.js